<template>
  <div style="margin-left: -15px">
    <el-form ref="formSearch" :inline="true" :model="formData" label-width="150px">
      <el-form-item label="会员昵称:">
        <el-input size="small" v-model="formData.theme" placeholder="请输入会员昵称"></el-input>
      </el-form-item>
      <el-form-item label="客户pin:">
        <el-input size="small" v-model="formData.fullName"></el-input>
      </el-form-item>
      <!-- <el-form-item label="手机号码:">
        <el-input size="small" v-model="formData.monile"></el-input>
      </el-form-item> -->
      <el-form-item label="会员等级:">
        <el-select v-model="formData.orderRemark">
          <el-option v-for="(item, index) in remartList" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
        <!-- <el-select v-model="formData.activityType">
          <el-option
            v-for="(item, index) in remartListOne"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="是否开卡:">
        <el-select v-model="formData.orderstatus">
          <el-option v-for="(item, index) in remartListTwo" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开卡时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeStart"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size: 12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeEnd"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px; font-size: 12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeOrderTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item label="最后参与活动时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.sendStartTimeStart"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size: 12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.sendStartTimeEnd"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px; font-size: 12px"
            class="time2"
            :clearable="true"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item label="生日时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.birthDayStart"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 120px; font-size: 12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.birthDayEnd"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 145px; font-size: 12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeBirthDay()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
        <div
          style="text-align: center; display: inline-block;
          margin-left: 50px;"
        >
          <el-button size="small" :disabled="tableLoding" class="search" v-zoom="{ from: pageName, name: '查询' }" @click="submitForm('formSearch')">
            <i
              class="el-icon-search"
              style="
              display: inline-block;
              width: 14px;
              height: 12px;
              fontweight: bold;
            "
            ></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="resetForm">重置</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
export default {
  name: "input_form",
  props: {
    orderStatusType: {
      type: Array,
      default: () => [],
    },
    pageName: {
      type: String,
    },
  },
  data() {
    return {
      formData: {
        theme: "", //活动主题
        concent: "", //短信内容
        orderRemark: "", //活动类型
        activityType: "",
        orderstatus: "", //发送状态
        orderStartTimeStart: "", //提交时间开始
        orderStartTimeEnd: "", //提交时间结束
        sendStartTimeStart: "", //发送时间开始
        sendStartTimeEnd: "", //发送时间结束
        monile: "",
        birthDayStart: "", //生日时间开始
        birthDayEnd: "", //生日时间结束
      },
      remartList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "非会员",
          value: 0,
        },
        {
          label: "一星会员",
          value: 1,
        },
        {
          label: "二星会员",
          value: 2,
        },
        {
          label: "三星会员",
          value: 3,
        },
        {
          label: "四星会员",
          value: 4,
        },
        {
          label: "五星会员",
          value: 5,
        },
      ],
      remartListOne: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "短信测试",
          value: 0,
        },
        {
          label: "会员发送",
          value: 1,
        },
        {
          label: "订单发送",
          value: 2,
        },
        {
          label: "输入号码发送",
          value: 4,
        },
        {
          label: "指定号码发送",
          value: 5,
        },
        {
          label: "变量短信发送",
          value: 6,
        },
        {
          label: "手动催平",
          value: 7,
        },
        {
          label: "手动回评",
          value: 8,
        },
        {
          label: "手动审核退款",
          value: 9,
        },
        {
          label: "营销汇总分析发送",
          value: 10,
        },
      ],
      remartListTwo: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已开卡",
          value: 1,
        },
        {
          label: "未开卡",
          value: 0,
        },
      ],
      payTypeList: [
        {
          label: "货到付款",
          value: 1,
        },
        {
          label: "邮局汇款",
          value: 2,
        },
        {
          label: "自提",
          value: 3,
        },
        {
          label: "在线支付",
          value: 4,
        },
        {
          label: "公司转账",
          value: 5,
        },
        {
          label: "银行转账",
          value: 6,
        },
      ],
      deliveryTypeList: [
        {
          label: "任意时间",
          value: "",
        },
        {
          label: "只工作日送货(双休日、假日不用送)",
          value: "1",
        },
        {
          label: "只双休日、假日送货(工作日不用送)",
          value: "2",
        },
        {
          label: "工作日、双休日与假日均可送货",
          value: "3",
        },
      ],
      orderSourceList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "PC端订单",
          value: "PC端订单",
        },
        {
          label: "农村电商",
          value: "农村电商",
        },
        {
          label: "微信订单",
          value: "微信订单",
        },
        {
          label: "手Q订单",
          value: "手Q订单",
        },
        {
          label: "移动端订单",
          value: "移动端订单",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      tableLoding: false,
      city: "",
      mytimestart: "",
      mytimeend: "",
    };
  },
  mounted() {
    this.time();
    this.getLevel();
  },
  methods: {
    time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      this.mytimestart = this.getDateStr(-30) + " 00:00:00";
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
      this.formData = {
        orderStartTimeStart: this.mytimestart, //提交时间开始
        orderStartTimeEnd: this.mytimeend, //提交时间结束
        // sendStartTimeStart: this.mytimestart, //发送时间开始
        // sendStartTimeEnd: this.mytimeend, //发送时间结束
      };
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          this.levelList = [];
          if (res.data[0]) {
            this.remartList[2].label = res.data[0].customerLevelName;
          }
          if (res.data[1]) {
            this.remartList[3].label = res.data[1].customerLevelName;
          }
          if (res.data[2]) {
            this.remartList[4].label = res.data[2].customerLevelName;
          }
          if (res.data[3]) {
            this.remartList[5].label = res.data[3].customerLevelName;
          }
          if (res.data[4]) {
            this.remartList[6].label = res.data[4].customerLevelName;
          }
          this.remartList.splice(res.data.length + 2, 5);
        })
        .catch((res) => {});
    },
    clearTimeOrderTime() {
      this.formData.orderStartTimeStart = "";
      this.formData.orderStartTimeEnd = "";
      // this.formData.sendStartTimeStart = "";
      // this.formData.sendStartTimeEnd = "";
    },
    clearTimeSendTime() {
      // this.formData.orderStartTimeStart = "";
      // this.formData.orderStartTimeEnd = "";
      this.formData.sendStartTimeStart = "";
      this.formData.sendStartTimeEnd = "";
    },
    clearTimeBirthDay() {
      this.formData.birthDayStart = "";
      this.formData.birthDayEnd = "";
    },
    submitForm() {
      this.$emit("onSerach", this.formData);
    },
    resetForm() {
      this.formData = {
        pin: "",
        fullName: "",
        mobile: "",
        orderId: "",
        waybill: "",
        orderPaymentStart: "",
        orderPaymentEnd: "",
        orderStartTimeStart: "",
        orderStartTimeEnd: "",
        orderState: "",
        deliveryType: "",
        wareIds: "",
        orderSource: "",
        orderRemark: "",
        orderRemarkContent: "",
        skuName: "",
        skuName: "",
        skuName: "",
        orderstatus: "",
      };
      this.$emit("onSerach", this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/.my_select_time .el-input__inner {
//   padding: 0px 8px !important;
// }
.el-input,
.el-select {
  width: 280px;
}
.search {
  width: 98px;
  height: 32px;
  font-size: 14px;
  border-radius: 3px;
  color: #fff;
  border: 1px solid #7b61ff;
  background-color: #7b61ff;
  &:hover {
    opacity: 0.8;
  }
}
.reset {
  width: 98px;
  height: 32px;
  color: #666666;
  font-size: 14px;
  border-radius: 3px;
  border-radius: 3px;
  border: 1px solid #7b61ff;
  background-color: #fff;
  &:hover {
    color: #fff;
    border: 1px solid #7b61ff;
    background-color: #7b61ff;
  }
}
.range-num {
  .el-input {
    width: 125px;
  }
  .to {
    padding: 0 8px;
  }
}
.select-input-type {
  .el-select {
    width: 136px;
    margin-right: 8px;
  }
  .el-input {
    width: 136px;
  }
}
.btn_group {
  text-align: center;
}
</style>
